import { YearTypeConst } from "constants/YearTypeConstant";

export default function getYearName(yearType, year) {
  return yearType && yearType === YearTypeConst.Maly
    ? `${(year - 1).toString()}/${year.toString()}`
    : year.toString();
}
